import React, { Dispatch, SetStateAction } from "react";
import { StepTypes } from "./MortgageShareFlow";

interface MortgageShareFlowTopTabsProps {
  step: string;
  setStep: Dispatch<SetStateAction<StepTypes>>;
}

const MortgageShareFlowTopTabs = (props: MortgageShareFlowTopTabsProps) => {
  const { step, setStep } = props;

  return (
    <ul className="relative text-center mb-8 rounded-[5px] bg-[#fbfbfb] shadow-lg tab-buttons">
      <li
        onClick={(tab) => setStep("preview")}
        className={`relative block text-sm bg-white text-gray-600 font-medium leading-6 cursor-pointer float-left rounded-[3px] py-3 px-10 capitalize transition-all duration-500 ${step === "preview" ? "!text-white !bg-[#00ab15]" : ""}`}
      >
        Preview
      </li>
      <li
        onClick={(tab) => setStep("applicant")}
        className={`relative block text-sm bg-white text-gray-600 font-medium leading-6 cursor-pointer float-left rounded-[3px] py-3 px-10 capitalize transition-all duration-500 ${step === "applicant" ? "!text-white !bg-[#00ab15]" : ""}`}
      >
        Applicant
      </li>
      <li
        onClick={(tab) => setStep("liabilities")}
        className={`relative block text-sm bg-white text-gray-600 font-medium leading-6 cursor-pointer float-left rounded-[3px] py-3 px-10 capitalize transition-all duration-500 ${step === "liabilities" ? "!text-white !bg-[#00ab15]" : ""}`}
      >
        Liabilities
      </li>
      <li
        onClick={(tab) => setStep("assets")}
        className={`relative block text-sm bg-white text-gray-600 font-medium leading-6 cursor-pointer float-left rounded-[3px] py-3 px-10 capitalize transition-all duration-500 ${step === "assets" ? "!text-white !bg-[#00ab15]" : ""}`}
      >
        Assets
      </li>
      <li
        onClick={(tab) => setStep("banking-details")}
        className={`relative block text-sm bg-white text-gray-600 font-medium leading-6 cursor-pointer float-left rounded-[3px] py-3 px-10 capitalize transition-all duration-500 ${step === "banking-details" ? "!text-white !bg-[#00ab15]" : ""}`}
      >
        Banking Details
      </li>
      <li
        onClick={(tab) => setStep("review")}
        className={`relative block text-sm bg-white text-gray-600 font-medium leading-6 cursor-pointer float-left rounded-[3px] py-3 px-10 capitalize transition-all duration-500 ${step === "review" ? "!text-white !bg-[#00ab15]" : ""}`}
      >
        Review
      </li>
    </ul>
  );
};

export default MortgageShareFlowTopTabs;
